 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		113: 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"vendors~intl-relativetimeformat~polyfills","2":"lang_af","3":"lang_ar","4":"lang_be","5":"lang_bg","6":"lang_bs","7":"lang_ca","8":"lang_cs","9":"lang_da","10":"lang_de","11":"lang_el","12":"lang_es","13":"lang_et","14":"lang_fi","15":"lang_fil","16":"lang_fr","17":"lang_he","18":"lang_hi","19":"lang_hr","20":"lang_hu","21":"lang_id","22":"lang_is","23":"lang_it","24":"lang_ja","25":"lang_ka","26":"lang_kk","27":"lang_ko","28":"lang_ky","29":"lang_lt","30":"lang_lv","31":"lang_nl","32":"lang_no","33":"lang_pa","34":"lang_pl","35":"lang_pt","36":"lang_pt_br","37":"lang_ro","38":"lang_ru","39":"lang_sk","40":"lang_sl","41":"lang_sq","42":"lang_sr","43":"lang_sr_me","44":"lang_sv","45":"lang_sw","46":"lang_th","47":"lang_tr","48":"lang_tw","49":"lang_uk","50":"lang_ur","51":"lang_uz","52":"lang_vi","53":"lang_zh_cn","54":"lang_zh_tw","55":"locale_ak","56":"locale_ar","57":"locale_be","58":"locale_bg","59":"locale_bs","60":"locale_ca","61":"locale_cs","62":"locale_da","63":"locale_de","64":"locale_el","65":"locale_en","66":"locale_es","67":"locale_et","68":"locale_fi","69":"locale_fil","70":"locale_fr","71":"locale_he","72":"locale_hi","73":"locale_hr","74":"locale_hu","75":"locale_id","76":"locale_is","77":"locale_it","78":"locale_ja","79":"locale_ka","80":"locale_kk","81":"locale_ko","82":"locale_ky","83":"locale_lt","84":"locale_lv","85":"locale_nl","86":"locale_pa","87":"locale_pl","88":"locale_pt","89":"locale_ro","90":"locale_ru","91":"locale_sk","92":"locale_sl","93":"locale_sq","94":"locale_sr","95":"locale_sr_cyrl_me","96":"locale_sv","97":"locale_sw","98":"locale_th","99":"locale_tr","100":"locale_uk","101":"locale_ur","102":"locale_uz","103":"locale_vi","104":"locale_zh","105":"loclae_af","106":"polyfills","108":"vendors~css-vars-ponyfill","109":"vendors~dompurify","110":"vendors~marked","111":"vendors~polyfills"}[chunkId]||chunkId) + "." + {"0":"da96b80a3e35ba64e923","2":"f0e90be23a12fcbeda16","3":"4b30ca364f3881310fee","4":"59e1cadd55e338257f94","5":"17bc2d92d9c396765144","6":"d8c14052de8c37efea21","7":"3067bc2acbb001ada3cc","8":"49b86022ef11241e817a","9":"715774e89dec1c2155a7","10":"44ab1924b49c0acd365c","11":"d222c461e4627635d348","12":"55e48ccee56398faefa7","13":"ca5f4eea85700e51eb95","14":"92d10808c0f5d8fa4121","15":"6fcf6bb61729924f9fda","16":"345a05ed1cd3c5828caf","17":"2a538361e2ac672fd994","18":"d27200979884dc910e30","19":"4fd893b0d0e88775f341","20":"53ddda19b1bccf30c354","21":"5384e1759d48d6e306da","22":"4498454f0f144491e65e","23":"917c5a364e1609532bba","24":"939ed6400ea27eac2b57","25":"61617fef3eb89915d20f","26":"58baa9d040030d6b7222","27":"61353056a55263efdf29","28":"1100d7287b01d0c19243","29":"41e88db83b84ceead4e1","30":"4f358d9a93596a9b9cae","31":"f6cc42da6f64ebf59c22","32":"31ca6f75c44574bb1910","33":"be23875122d932c95d0f","34":"8b20e9b965ebc43742ff","35":"264c2a27a1b1d631dc00","36":"083890c2d1c07a6c1b68","37":"8084296821ab5e9b060a","38":"a57687ee053399029daf","39":"fa0c35b5b9a4483d1a0b","40":"2127cbc1857e26ae8acf","41":"89e5d13c3cf228097a1e","42":"8210e724a5d6cb4e353f","43":"47b5bb677c2738117ca1","44":"00b26b47303efb290cc1","45":"481ffabaa92427032bd9","46":"c8294dd99c47d37fbaea","47":"003820d2041c146a0ba1","48":"da1c5e81e6298bdbc111","49":"e3c5dc824e194ca5c550","50":"e525f990af0bf279f391","51":"739b3f700081ebd0b2de","52":"e5f124421cafa41a3270","53":"41439f34b91e86ed36d8","54":"575723ca616b90c1dda6","55":"3cd47bf565dbb8549879","56":"5c607fa6ab82b5c84718","57":"ef778e4876c05f19d860","58":"a6d58ea6240dcec2e7d3","59":"e1b555f7e352369f4d8c","60":"bdce3b4c21f09b8809bc","61":"65f2f37d6212ea9a713c","62":"bbfd016d72883c4867c4","63":"c1209911fd3e09028872","64":"e7f5f7c91bda4ac9394e","65":"afb07c5cfaa7d1ed6b3b","66":"232c5177a54631964447","67":"ed2b039a25b50d9470cf","68":"acd3c3a9b575bfd709be","69":"449dab33b838ceb3d303","70":"fdb09ea9d0b7387000ff","71":"716b0bb9d02d59d815ec","72":"327647f9013e29d1eb55","73":"d520981ea83101d73378","74":"bf2bdf1fa5ae7ecc76dd","75":"31ae54ac0d29975f6f48","76":"e8fe2a5ff819f42c6156","77":"28c28f5c46cf4ca4c1d4","78":"1f6b0ed0f5932961e102","79":"02cf21b89d4ab47a610f","80":"671606dce03344a90ea2","81":"577f872468754de48b66","82":"032a37f08c9d32dd4539","83":"965fd43d00b2a96aae77","84":"5f36d5fbbd60ea7b879e","85":"3e491d17236ba072deae","86":"8315fba98578637f0b72","87":"85c82061abc0a3abe1e2","88":"ee27d8d0b36af27d784a","89":"c2974b65b3bf466c1322","90":"218ef3303177a16432af","91":"d94d92f16a2aef82f0f4","92":"328ceb76585a7658bdde","93":"c157c6947b51f79d4758","94":"bc83dbcc85f843af3d2c","95":"046f7b2996751f823166","96":"af67bc11fb268d84bcec","97":"e2c79c69bce66a8e2fab","98":"ebece95608495c974bf6","99":"081591c688f0c0f952dc","100":"8dc968f88cd33e83f366","101":"ac9460584cea3ded3dc9","102":"29c1e384bbbb17befaae","103":"657a00ac392a169ea06a","104":"5581dd6bcea693ada554","105":"330e82bfe48b1be7c70c","106":"861991d608d4017ad01d","108":"ff798725c14f55ede015","109":"9383ec165c4391be6cc7","110":"243b290686bddc5deb0d","111":"ab23c4d07df21dfe0840"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://cdn.kustomerapp.com/chat-web/release-v0.1.244/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["kustomer_chat_webpackJsonp"] = window["kustomer_chat_webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 93);
